module.exports = __webpack_public_path__ + "static/img/a102.a066db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a102.jpg
// module id = lvh0
// module chunks = 0